import rules from "@/config/rules";

export default {
  loadMainApiData({ dispatch }) {
    dispatch('Settings/loadAppSettings')
      .then(() => {
        dispatch('Coordinates/initCoordinates')

        if (rules.isFeatureItinerariesEnabled) {
          dispatch('Routes/initRoutes')
        }
      })
  }
}
